import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainerCustom from "../../components/Common/TableContainerCustom";
import { Card, CardBody, Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { useAreaCols } from "./AreaListMemo";
import { withTranslation } from "react-i18next";
import { modalAreaShow } from "../../store/actions";
import FormNewArea from "./FormNewArea";
import { getAreas } from "store/Areas/actions";

const AreaList = (props) => {
    const dispatch = useDispatch();

    const { areas = [], areaModalShow, totalItems = 0 } = useSelector(state => ({
        areas: state.AreaReducer.areas || [],
        areaModalShow: state.AreaReducer.areaModalShow,
        totalItems: state.AreaReducer.totalItems || 0
    }));

    const [isEdit, setIsEdit] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [areaL, setAreaL] = useState(null);

    const handleSetEditArea = (area) => {
        setAreaL(area)
        setIsEdit(true)
        dispatch(modalAreaShow(true))
    }

     const handleSetDeleteArea = (area) => {
        setAreaL(area)
        setIsDelete(true)
        dispatch(modalAreaShow(true))
    }

    useEffect(() => {
        if(!areaModalShow) {
            setIsDelete(false)
            setIsEdit(false)
            setAreaL(null)
        }
    }, [areaModalShow]);
    
    const memoAreaCols = useAreaCols(areaL, handleSetEditArea, handleSetDeleteArea);

    /**
     * @param {*} pagination
     *
     */
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        active: true,
        for_: 'inventory',
        total: 0,
        search: {
            filter: null
        }
    });

    const handlePageChange = (newPage, search) => {
        setPagination(prev => ({
            ...prev,
            page: newPage,
            search: search || prev.search
        }));
    };

    const toggleModalAddArea = () => {
        setIsEdit(false)
        setAreaL(null)
        let areaModalShowL = !areaModalShow;
        dispatch(modalAreaShow(areaModalShowL));
    };

    const handleGetAreas = () => {
        dispatch(getAreas(pagination));
    };

    useEffect(() => {
        handleGetAreas();
    }, []);

    useEffect(() => {
       handleGetAreas();
    }, [pagination.page, pagination.pageSize, pagination.search]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={props.t("Areas")}
                        breadcrumbItem={props.t("Listado")}
                    />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <TableContainerCustom
                                        className="" addBtnNewFlag={true} 
                                        lblBtnAddNew = "Nueva Area" 
                                        handleAddNewClick={toggleModalAddArea}
                                        data={areas}
                                        isGlobalFilter={false}
                                        isAddOptions={false} serverSidePagination={{
                                            totalItems: totalItems,
                                            currentPage: pagination?.page,
                                            onPageChange: handlePageChange,
                                            search: pagination?.search
                                        }} customPageSize={pagination?.pageSize}
                                        columns={memoAreaCols} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal size={"md"} isOpen={areaModalShow} backdrop={'static'} toggle={toggleModalAddArea}>
                        <ModalHeader toggle={toggleModalAddArea} tag="h4">
                            {isEdit ? "Editar Area" : isDelete ? "Eliminar Area" : "Nueva Area"}
                        </ModalHeader>
                        <ModalBody>
                            <Row>           
                                <FormNewArea isEdit={isEdit} pagination={pagination} isDelete={isDelete} area={areaL} />
                            </Row>
                        </ModalBody>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    )

}
export default withTranslation()(AreaList);
//export default AreaList;